import { ImgText } from '../../shared/utils/Heading'
import { LinearGradientText } from './Layout'
import TabsComponent from '../../shared/components/Tabs/TabComponent';
import TabPanel from '../../shared/components/Tabs/TabPanel';
import useTabs from '../../shared/hook/useTabs';
import { Box } from '@mui/material';
import { Constants } from '../../shared/constants';
import { Link } from 'react-router-dom';
import TrainerLoginForm from './TrainerLoginForm';
import TrainerSignUpForm from './TrainerSignUpForm';

const tabsData = [
    {
        label: "Login", component: <TrainerLoginForm/>
    },
    {
        label: "Sign Up", component: <TrainerSignUpForm/>
    }
];

const TrainerSmallScreen = ({ tabPage }) => {
    const { value, handleChange } = useTabs(tabPage);
    return (
        <Box padding={"20px"}>

            <Box mb={2} >
                <Link to={'/'}><img src={Constants.customImages.Logo} alt="logo" width={"100px"} height={"auto"} /></Link>
                <Box mb={4} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <ImgText text={"Welcome!!"} sx={{ textAlign: "center" }} />
                    <LinearGradientText
                        text={
                            value === 0
                                ? "Trainer login to upload courses, share learning materials, and track how students are engaging with your content."
                                : "Trainer sign up to start guiding and inspiring learners."
                        }
                    />

                </Box>
                <Box>
                    <TabsComponent tabs={tabsData} value={value} onChange={handleChange} />
                    {tabsData.map((tab, index) => (
                        <TabPanel key={index} value={value} index={index}>
                            {tab.component}
                        </TabPanel>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default TrainerSmallScreen







